import React, { useEffect, useState } from "react";
import Sidebar from "../../Sidebar";
import Header from "../../Header";
import { Link, useHistory } from "react-router-dom";

import { API } from "../../../../API";
import axios from "axios";
import { FaEdit, FaDownload, FaTrash, FaPlay } from "react-icons/fa"; // Import icons


import { isAutheticated } from "../../../auth/authhelper";
import Pagination from "../../../pagination";
import swal from "sweetalert";
import { Player } from "video-react";
// import UserPaypal from "../../../customer/UserPaypal";
import Footer from "../../Footer";
import { Modal } from "react-bootstrap";
// import Modal from "react-modal";
export default function Lessions() {
  const { token } = isAutheticated();
  const history = useHistory();
  const [play, setPlay] = useState("");
  const [isModalOpen, setModalStatus] = useState(false);
  const [data, setData] = useState([]);
  const [success, setSuccess] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(15);
  const [showData, setShowData] = useState(data);
  const [loading, setLoading] = useState(true); // Loading state


  const loadData = () => {
    setLoading(true); // Set loading to true when fetching starts

    axios
      .get(`${API}/api/lesson/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log("Data fetched successfully", response.data.data);
        setData(response.data.data);
      })
      .catch((err) => {
        console.error("Error fetching data", err);
      })
      .finally(() => {
        setLoading(false); // Set loading to false when request finishes
      });
  };

  // useEffect to fetch data on mount and dependencies
  useEffect(() => {
    loadData();
  }, [success, token]);

  useEffect(() => {
    const loadData = () => {
      const indexOfLastPost = currentPage * itemPerPage;
      const indexOfFirstPost = indexOfLastPost - itemPerPage;
      setShowData(data.slice(indexOfFirstPost, indexOfLastPost));
    };

    loadData();
  }, [data, currentPage, itemPerPage]);


  //lounch model
  const [isLModalOpen, setIsModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleSave = async (id) => {
    // Check if both date and time are selected
    if (!selectedDate || !selectedTime) {
      swal("Warning", "Please select both date and time", "warning");
      return;
    }

    // Combine selected date and time into ISO 8601 format
    const formattedDate = `${selectedDate}T${selectedTime}:00Z`;
    try {
      // Send PATCH request to update the launch date
      const response = await axios.patch(
        `${API}/api/lesson/${id}/launchDate`,
        {
          launchDate: formattedDate, // Data payload
          launch_flag: true, // Ensure launch_flag is updated
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token for authorization
          },
        }
      );

      // Show success notification
      swal("Success", "Launch date updated successfully!", "success");


      // Refresh the state or UI
      setSuccess(!success);
      closeModal(); // Close modal after success
    } catch (error) {
      console.error("Error updating launch date:", error);
      swal("Error", error?.response?.data?.message || "Failed to update launch date", "error");
    }
  };
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadFile = async (fileUrl) => {
    try {
      setIsDownloading(true);
      // Fetch the file from the URL
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error(`Failed to fetch: ${response.statusText}`);

      // Convert response to a Blob (for binary data)
      const blob = await response.blob();

      // Extract the filename from the URL
      const fileName = fileUrl.split("/").pop().split("?")[0]; // Removes query params if any

      // Create a download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName; // Keep the original filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsDownloading(false);
      swal("Success", "Download Complete! 🎉", "success");
    } catch (error) {
      setIsDownloading(false);

      console.error("Error downloading file:", error.message);
      swal("Error", "Failed to download file", "error");
    }
  };

  const [videoSizes, setVideoSizes] = useState({});
  const [totalSize, setTotalSize] = useState(0);

  // Function to get file size
  const getFileSize = async (fileUrl, lessonId) => {
    try {
      const response = await fetch(fileUrl, { method: "HEAD" });
      const contentLength = response.headers.get("Content-Length");

      if (contentLength) {
        const fileSizeInMB = parseInt(contentLength, 10) / (1024 * 1024);
        setVideoSizes((prevSizes) => ({ ...prevSizes, [lessonId]: fileSizeInMB }));
      }
    } catch (error) {
      console.error("Error getting file size:", error.message);
    }
  };

  // Fetch file sizes when component mounts or showData changes
  useEffect(() => {
    if (showData?.length > 0) {
      showData.forEach((lesson) => {
        if (lesson.video) {
          getFileSize(lesson.video, lesson._id);
        }
      });
    }
  }, [showData]);

  // Calculate total file size
  useEffect(() => {
    const total = Object.values(videoSizes).reduce((acc, size) => acc + size, 0);
    setTotalSize(total.toFixed(2));
  }, [videoSizes]);

  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>Content Management - Videos</h4>

                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='/dashboard'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item'>
                      Content Management - Videos
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>
                <div className='card-body'>
                  <div className='row ml-0 mr-0  mb-10'>
                    <div className='col-sm-12 col-md-6'>
                      <div className='dataTables_length'>
                        <label className='w-100'>
                          Show{" "}
                          <select
                            style={{ width: "60px" }}
                            name=''
                            value={itemPerPage}
                            onChange={(e) => setItemPerPage(e.target.value)}
                            className='select-w custom-select custom-select-sm form-control form-control-sm'>
                            <option value='15'>15</option>
                            <option value='25'>25</option>
                            <option value='50'>50</option>
                            <option value='100'>100</option>
                          </select>{" "}
                          entries
                        </label>
                      </div>
                    </div>
                    <div className='col-sm-12 col-md-6'>
                      {/* Total File Size Display */}
                      <div style={{ marginTop: "20px", fontWeight: "bold", fontSize: "1.2rem" }}>
                        <span>Total Video Size: {totalSize} MB</span>
                      </div>
                      <div className='dropdown d-block'>
                        <Link to='/video/add'>
                          <button
                            type='button'
                            className='btn btn-primary add-btn waves-effect waves-light float-right'>
                            <i className='fa fa-plus' aria-hidden='true'></i>{" "}
                            Add New Video
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='table-responsive table-shoot'>
                    <table className='table table-centered table-nowrap mb-0'>
                      <thead className='thead-light text-center border'>
                        <tr className="border">
                          <th>Title</th>
                          <th>Size</th>

                          <th>Thumbnail</th>

                          <th>Status</th>
                          {/* <th>Net. Channel</th> */}
                          <th>Channel</th>

                          <th>Uploaded On</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="10" align="center" style={{ padding: "20px" }}>
                              <div style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#007bff" }}>
                                Loading...
                              </div>
                            </td>
                          </tr>
                        ) : showData?.length > 0 ? (
                          showData.map((lession) => {
                            return (
                              <tr key={lession._id}>
                                <td>{lession.title}
                                </td>
                                <td className=" text-gray-900 font-semibold">
                                  {lession.video
                                    ? videoSizes?.[lession._id]
                                      ? `${videoSizes[lession._id].toFixed(2)} MB`
                                      : "..."
                                    : "N/A"}
                                </td>

                                <td>
                                  <img
                                    src={
                                      lession.thumbnail
                                        ? lession.thumbnail
                                        : "/lessionDefault.png"
                                    }
                                    width='110'
                                    height='60'
                                    alt=''
                                  />
                                </td >

                                {/* {new Date(lession?.launchDate).toDateString()} */}
                                {/* <td>
                                  {lession?.launchDate ? (
                                    new Date(lession?.launchDate).toDateString()
                                  ) : (
                                    <>
                                      <button
                                        className="btn btn-warning bg-success btn-sm"
                                        onClick={openModal}
                                      >
                                        Set Date
                                      </button>

                                      <div
                                        className={`modal fade ${isLModalOpen ? "show" : ""}`}
                                        tabIndex="-1"
                                        style={{ display: isLModalOpen ? "block" : "none" }}
                                        aria-labelledby="exampleModalLabel"
                                        aria-hidden={!isLModalOpen}
                                      >
                                        <div className="modal-dialog modal-dialog-centered">
                                          <div className="modal-content">
                                            <div className="modal-header">
                                              <h3 className="modal-title" id="exampleModalLabel">
                                                Set Launch Date and Time
                                              </h3>
                                              <button
                                                type="button"
                                                className="btn-close"
                                                onClick={closeModal}
                                                aria-label="Close"
                                              ></button>
                                            </div>
                                            <div className="modal-body">
                                              <form>
                                                <div className="mb-3">
                                                  <label className="form-label">Select Date</label>
                                                  <input
                                                    type="date"
                                                    className="form-control"
                                                    value={selectedDate}
                                                    onChange={(e) => setSelectedDate(e.target.value)}
                                                    min={new Date().toISOString().split("T")[0]} // Restrict to today or future
                                                  />
                                                </div>
                                                <div className="mb-3">
                                                  <label className="form-label">Select Time</label>
                                                  <input
                                                    type="time"
                                                    className="form-control"
                                                    value={selectedTime}
                                                    onChange={(e) => setSelectedTime(e.target.value)}
                                                  />
                                                </div>
                                              </form>
                                            </div>
                                            <div className="modal-footer">
                                              <button
                                                type="button"
                                                className="btn btn-success"
                                                onClick={(e) => handleSave(lession?._id)}
                                              >
                                                Save
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={closeModal}
                                              >
                                                Cancel
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </td> */}
                                <td>
                                  {/* {lession?.launchDate &&
                                  new Date(lession?.launchDate).toDateString()
                                } */}
                                  {/* {console.log(lession?.video)}
                                  {lession?.video &&
                                    <button
                                      className="badge badge-pill badge-success font-size-12"
                                      onClick={() => downloadFile(lession?.video)}
                                    >
                                      Download
                                    </button>} */}



                                  {lession?.live ? (

                                    <span className='badge badge-pill badge-success font-size-12'>
                                      Live
                                    </span>
                                  ) : (
                                    <span className='badge badge-pill badge-soft-danger font-size-12'>
                                      Live
                                    </span>
                                  )}</td>
                                <td className="text-center">
                                  {lession.channel?.name}

                                </td>
                                {/* <td className="text-center">
                                  {lession.channelType === "Channels"
                                    ? lession.channel?.name
                                    : "---"}
                                </td>
                                <td className="text-center">
                                  {lession.channelType === "Subchannels"
                                    ? lession.channel?.name
                                    : "---"}
                                </td> */}
                                <td>
                                  {new Date(lession.createdAt).toLocaleDateString("en-US", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  })}
                                </td>


                                <td>
                                  {lession.live &&
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.preventDefault();

                                        axios
                                          .patch(
                                            `${API}/api/lesson/${lession._id}/suspend`, {},
                                            {
                                              headers: {
                                                Authorization: `Bearer ${token}`,
                                              },
                                            }
                                          )
                                          .then((res) => {
                                            setSuccess(!success);
                                            swal({
                                              title:
                                                "Video Unpublish Successfully!",

                                              icon: "success",
                                              buttons: true,
                                              successMode: true,
                                              dangerMode: false,
                                            });
                                            // console.log(res);
                                          })
                                          .catch((err) => {
                                            console.log(err);
                                            setSuccess(!success);
                                          });
                                      }}
                                      className="btn btn-secondary btn-sm  waves-effect waves-light btn-table"
                                    >
                                      Unpublish
                                    </button>}
                                  {!lession.live && (
                                    <button
                                      type='button'
                                      onClick={(e) => {
                                        e.preventDefault();

                                        axios
                                          .patch(
                                            `${API}/api/lesson/makelive/${lession._id}`,
                                            {},
                                            {
                                              headers: {
                                                Authorization: `Bearer ${token}`,
                                              },
                                            }
                                          )
                                          .then((res) => {
                                            setSuccess(!success);
                                            swal({
                                              title: "Video is live!",

                                              icon: "success",
                                              buttons: true,
                                              successMode: true,
                                              dangerMode: false,
                                            });
                                            // console.log(res);
                                          })
                                          .catch((err) => {
                                            console.log(err);
                                            setSuccess(!success);
                                          });
                                      }}
                                      className='btn btn-success btn-sm  waves-effect waves-light btn-table'>
                                      Publish
                                    </button>
                                  )}

                                  {/* <Link to={`/lessions/view/${lession._id}`}>
                                    <button
                                      type="button"
                                      className="btn btn-info btn-sm  waves-effect waves-light btn-table ml-2"
                                    >
                                      View
                                    </button>
                                  </Link> */}




                                  {lession?.channelType !== "Subchannels" ? (
                                    <Link to={`/video/edit/${lession._id}`}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm waves-effect waves-light"
                                      >
                                        <FaEdit />
                                      </button>
                                    </Link>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-secondary btn-sm waves-effect waves-light"
                                      onClick={() =>
                                        swal({
                                          title: "Access Restricted",
                                          text: "Only this channel and network channels can edit this video.",
                                          icon: "info",
                                          button: "OK",
                                        })
                                      }
                                    >
                                      <FaEdit />
                                    </button>
                                  )}





                                  {lession?.video && (
                                    <button
                                      className=" btn btn-success btn-sm  waves-effect waves-light btn-table"
                                      onClick={() => downloadFile(lession?.video)}
                                      disabled={isDownloading}
                                    >
                                      {/* <i className="fas fa-download"></i> FontAwesome Download Icon */}
                                      <FaDownload className="mr-1" />
                                      {/* {isDownloading ? "Downloading..." : "Download"} */}
                                    </button>
                                  )}


                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      let status = window.confirm(
                                        "Do you want to delete"
                                      );
                                      if (!status) {
                                        return;
                                      } else {
                                        axios
                                          .delete(
                                            `${API}/api/lesson/${lession._id}`,
                                            {
                                              headers: {
                                                Authorization: `Bearer ${token}`,
                                              },
                                            }
                                          )
                                          .then((res) => {
                                            setSuccess(!success);
                                            swal({
                                              title:
                                                "Video deleted Successfully!",

                                              icon: "success",
                                              buttons: true,
                                              successMode: true,
                                              dangerMode: false,
                                            });
                                            // console.log(res);
                                          })
                                          .catch((err) => {
                                            console.log(err);
                                            setSuccess(!success);
                                          });
                                      }
                                    }}
                                    type='button'
                                    className='btn btn-danger btn-sm  waves-effect waves-light btn-table ml-2'
                                    id='sa-params'>
                                    <FaTrash className="mr-1" />                                  </button>
                                  <button
                                    type='button'
                                    onClick={() => {
                                      setPlay(lession.video);
                                      setModalStatus(true);
                                    }}
                                    className='btn btn-success btn-sm  waves-effect waves-light btn-table ml-2'>
                                    <FaPlay className="mr-1" />
                                  </button>



                                  {/* <Link to={`/lessions/add-studio/${lession._id}`}>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm  waves-effect waves-light btn-table ml-2"
                                    >
                                      Studio
                                    </button>
                                  </Link> */}


                                  <a
                                    href={`/video/add-commerce/${lession._id}`}
                                    className="btn btn-primary btn-sm waves-effect waves-light btn-table ml-2"
                                  // onClick={(e) => {
                                  //   e.preventDefault(); // Prevent default navigation (optional, depending on your use case)
                                  //   window.location.href = `/lessions/add-commerce/${lession._id}`; // Navigate to the new URL
                                  // }}
                                  >
                                    Add Commerce and Ads
                                  </a>

                                </td>
                              </tr>
                            );
                          })) : (
                          <tr>
                            <td colSpan="5" className="text-center py-4" style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#ff0000" }}>
                              No Vedio Found. Please add New Vedio to display here.
                            </td>
                          </tr>
                        )}

                        <Modal
                          className='modal-container'
                          show={isModalOpen}
                          onHide={() => setModalStatus(false)}>
                          <Modal.Body style={{ backgroundColor: "black" }}>
                            <Player>
                              <source src={play} />
                            </Player>
                          </Modal.Body>
                        </Modal>
                      </tbody>
                    </table>
                  </div>

                  <div className='row mt-20'>
                    <div className='col-sm-12 col-md-6 mb-20'>
                      <div
                        className='dataTables_info'
                        id='datatable_info'
                        role='status'
                        aria-live='polite'>
                        Showing {currentPage * itemPerPage - itemPerPage + 1} to{" "}
                        {Math.min(currentPage * itemPerPage, data.length)} of{" "}
                        {data.length} entries
                      </div>
                    </div>

                    <div className='col-sm-12 col-md-6'>
                      <div className='dataTables_paginate paging_simple_numbers float-right'>
                        <ul className='pagination'>
                          <li
                            className={
                              currentPage === 1
                                ? "paginate_button page-item previous disabled"
                                : "paginate_button page-item previous"
                            }>
                            <a
                              rel='noreferrer'
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='0'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev - 1)
                              }>
                              Previous
                            </a>
                          </li>

                          {!(currentPage - 1 < 1) && (
                            <li className='paginate_button page-item'>
                              <a
                                aria-controls='datatable'
                                data-dt-idx='1'
                                tabIndex='0'
                                rel='noreferrer'
                                href='#'
                                className='page-link'
                                onClick={(e) =>
                                  setCurrentPage((prev) => prev - 1)
                                }>
                                {currentPage - 1}
                              </a>
                            </li>
                          )}

                          <li className='paginate_button page-item active'>
                            <a
                              rel='noreferrer'
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='2'
                              tabIndex='0'
                              className='page-link'>
                              {currentPage}
                            </a>
                          </li>

                          {!(
                            (currentPage + 1) * itemPerPage - itemPerPage >
                            data.length
                          ) && (
                              <li className='paginate_button page-item '>
                                <a
                                  rel='noreferrer'
                                  href='#'
                                  aria-controls='datatable'
                                  data-dt-idx='3'
                                  tabIndex='0'
                                  className='page-link'
                                  onClick={() => {
                                    setCurrentPage((prev) => prev + 1);
                                  }}>
                                  {currentPage + 1}
                                </a>
                              </li>
                            )}

                          <li
                            className={
                              !(
                                (currentPage + 1) * itemPerPage - itemPerPage >
                                data.length
                              )
                                ? "paginate_button page-item next"
                                : "paginate_button page-item next disabled"
                            }>
                            <a
                              rel='noreferrer'
                              href='#'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev + 1)
                              }>
                              Next
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div >
  );
}
